module.exports = __webpack_public_path__ + "img/kerstin_cv_4.acc32057.jpg";